var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp-box flex-direction-box"},[_c('v-header'),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.add}},[_vm._v("add")])],1),_vm._v(" "),_c('craft',{ref:"craft",attrs:{"craft-line":_vm.craftLine,"add-before":_vm.addBefore},on:{"get-list":_vm.getList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726fedb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/基础数据管理/craftLine.vue
// module id = THLI
// module chunks = 88